import createReactComponent from '../createReactComponent';
export default createReactComponent('bookmark-plus', 'IconBookmarkPlus', [
  [
    'path',
    { d: 'M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v5', key: 'svg-0' },
  ],
  ['path', { d: 'M16 19h6', key: 'svg-1' }],
  ['path', { d: 'M19 16v6', key: 'svg-2' }],
]);
